"use client"; // Marking as Client Component for mobile menu toggle

import { useState } from "react";
import { Link, useLocation } from "react-router";
import Block from "src/UIKit/Components/Block";
import Typography from "src/UIKit/Components/Typography";
import Icon from "src/UIKit/Components/Icon";
import FastPicture from "src/UIKit/Components/FastPicture";
import { icons } from "src/assets/index";

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isLargeScreen = window.innerWidth >= 1024;

  const handleNavClick = () => {
    if (!isLargeScreen) {
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    // {
    //   group: "Main",
    //   links: [{ href: "/", label: "Home" }],
    // },
    // {
    //   group: "Coupon",
    //   links: [{ href: "/coupon-management", label: "Coupon Management" }],
    // },
    {
      group: "Exam",
      links: [
        // {
        //   href: "/exam-feed-back-management",
        //   label: "Exam Feedback Management",
        // },
        {
          href: "/mock-test-rules",
          label: "Mock Test Rules",
        },
        {
          href: "/mock-test-generation",
          label: "Mock Test Generation",
        },
      ],
    },
    // {
    //   group: "Referrals",
    //   links: [{ href: "/referral-levels", label: "Referral Levels" }],
    // },
    // {
    //   group: "Counselling",
    //   links: [{ href: "/personal-counselling", label: "Personal Counselling" }],
    // },
  ];

  return (
    <>
      {/* Vertical Navbar */}
      <Block
        component="nav"
        className={`fixed left-0 top-0 h-screen w-64 z-50 shadow-lg bg-background flex flex-col py-8 px-6 transition-transform duration-300 ${
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0`}
      >
        {/* Toggle Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
          className="absolute -right-12 top-4 p-2 bg-background shadow-lg rounded-r-lg transition-colors hover:bg-gray-50 lg:hidden"
        >
          <Icon
            name={isMobileMenuOpen ? "MdChevronLeft" : "MdChevronRight"}
            className="w-6 h-6 text-gray-700"
          />
        </button>

        {/* Logo */}
        <Block className="mb-12">
          <Link to="/">
            <FastPicture
              source={icons.logo_black_orange}
              width={120}
              height={40}
              className="w-36 h-auto"
            />
          </Link>
        </Block>

        {/* Navigation Links */}
        <Block className="flex-1 space-y-8 overflow-y-auto">
          {navLinks.map(group => (
            <Block key={group.group} className="space-y-2">
              <Typography className="text-base font-semibold text-gray-900 tracking-wide px-3">
                {group.group}
              </Typography>
              {group.links.map(link => (
                <Block key={link.href}>
                  <Link
                    to={link.href}
                    className={`flex items-center transition-colors px-6 py-2 rounded-lg w-full ${
                      location.pathname === link.href
                        ? "bg-primary/10 text-primary"
                        : "hover:bg-gray-50 text-gray-600 hover:text-primary"
                    }`}
                    onClick={handleNavClick}
                  >
                    <Typography
                      className={`text-sm font-medium transition-colors ${
                        location.pathname === link.href
                          ? "text-primary"
                          : "text-gray-600 hover:text-primary"
                      }`}
                    >
                      {link.label}
                    </Typography>
                  </Link>
                </Block>
              ))}
            </Block>
          ))}
        </Block>

        {/* CTA Button */}
        {/* <Block className="mt-auto pt-6">
          <Link
            to="#get-started"
            className="bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors block text-center font-medium"
            onClick={handleNavClick}
          >
            Get Started
          </Link>
        </Block> */}
      </Block>

      {/* Overlay for Mobile/Tablet Menu */}
      {isMobileMenuOpen && (
        <Block
          className="lg:hidden fixed inset-0 bg-black/20 backdrop-blur-sm z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
}
